/* Decorative pointer response only. Native links handle navigation. */
if (!customElements.get('ys-halloween-hero-art')) {
  customElements.define('ys-halloween-hero-art', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.dataset.motion !== 'true') return;
      this.controller = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.pointer = matchMedia('(hover: hover) and (pointer: fine)');
      const options = { signal: this.controller.signal };
      this.addEventListener('pointermove', event => {
        if (this.reduced.matches || !this.pointer.matches || event.pointerType === 'touch') return;
        const rect = this.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const x = Math.max(-.5, Math.min(.5, (event.clientX - rect.left) / rect.width - .5));
        const y = Math.max(-.5, Math.min(.5, (event.clientY - rect.top) / rect.height - .5));
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.style.setProperty('--hw-art-x', (x * 8).toFixed(2) + 'px');
          this.style.setProperty('--hw-art-y', (y * 6).toFixed(2) + 'px');
          this.style.setProperty('--hw-art-light', (1.02 + (x + .5) * .045).toFixed(3));
        });
      }, { ...options, passive: true });
      this.addEventListener('pointerleave', () => this.reset(), options);
      this.reduced.addEventListener('change', () => this.reset(), options);
      this.pointer.addEventListener('change', () => this.reset(), options);
    }
    reset() {
      cancelAnimationFrame(this.frame);
      this.style.removeProperty('--hw-art-x');
      this.style.removeProperty('--hw-art-y');
      this.style.removeProperty('--hw-art-light');
    }
    disconnectedCallback() {
      this.reset();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

